import { useSearchParams } from 'next/navigation';

export type HashDataObject = {
  category?: string;
  position?: string;
  searchNo?: boolean;
  token?: string;
};

export const useHashParameters = (): HashDataObject => {
  const searchParams = useSearchParams();

  const hashParams =
    typeof window === 'undefined'
      ? undefined
      : new URLSearchParams(window.location.hash.substring(1));

  return {
    category: searchParams?.get('nav-c') ?? hashParams?.get('nav-c') ?? undefined,
    position: searchParams?.get('nav-i') ?? hashParams?.get('nav-i') ?? undefined,
    searchNo: searchParams?.get('search-no') === 'true' || hashParams?.get('search-no') === 'true',
    token: hashParams?.get('token') ?? undefined,
  };
};
